import BugReportIcon from '@mui/icons-material/BugReport';
import Tooltip from '@mui/material/Tooltip';

interface BugHistoryIconProps {
  /** Tổng số bug từng báo cho tính năng (kể cả đã xử lý xong). */
  totalBugCount?: number;
  /** Số bug còn mở — chỉ dùng để làm rõ tooltip. */
  openBugCount?: number;
}

/**
 * Dấu hiệu "tính năng này đã từng có lỗi".
 *
 * Chip trạng thái chỉ nói được tình trạng HIỆN TẠI: bug đóng hết là tính năng
 * quay về "Hoàn thành" và lịch sử lỗi biến mất khỏi danh sách. Icon này giữ lại
 * thông tin đó nên trả về null khi tính năng chưa từng có bug.
 */
export function BugHistoryIcon({
  totalBugCount,
  openBugCount,
}: BugHistoryIconProps): JSX.Element | null {
  const total = totalBugCount ?? 0;
  if (total <= 0) return null;

  const open = openBugCount ?? 0;
  const detail = open > 0 ? `${total} lỗi, ${open} đang mở` : `${total} lỗi, đã xử lý`;

  return (
    <Tooltip title={`Đã từng được báo lỗi (${detail})`}>
      <BugReportIcon
        fontSize="inherit"
        color="error"
        sx={{ fontSize: 14, opacity: 0.75, flexShrink: 0 }}
        data-testid="bug-history-icon"
      />
    </Tooltip>
  );
}
